import type { ProductHitPrice } from '@libs/algolia';
import type { ProductPrice } from '@app/pdp/components/ProductPrice/types';
import { productPriceVariantMapper } from './productPriceVariantMapper';

export const productPriceMapper = (
    productPrice: ProductHitPrice
): ProductPrice => {
    const mappedProductPrice: ProductPrice = {
        values: [],
        variant: 'primary',
        isStrikethrough: false,
    };

    if (!productPrice) {
        return mappedProductPrice;
    }

    const strikethrough = productPrice['strikethrough-number'];

    if (strikethrough) {
        const values = [productPrice.number];

        values.push(strikethrough);

        mappedProductPrice.values = values;
        mappedProductPrice.variant = productPriceVariantMapper(productPrice);
        mappedProductPrice.isStrikethrough = true;

        return mappedProductPrice;
    }

    mappedProductPrice.values = [productPrice.number];
    mappedProductPrice.variant = 'primary';
    mappedProductPrice.isStrikethrough = false;

    return mappedProductPrice;
};
